import { Route, Routes } from 'react-router-dom';
import AdminUser from '../components/admin-user/admin-user';
import { Countries } from '../components/countries/Countries';
import { Programs } from '../components/programs/Programs';
import { CreateCountry } from '../components/createCountry/CreateCountry';
import { CreateNewProgram } from '../components/createNewProgram/CreateNewProgram';

export const RoutesAdmin = ({ changeNotifications }: any) => {
  return (
    <>
      <Routes>
        <Route
          path='/'
          element={<AdminUser changeNotifications={changeNotifications} />}
        />
        <Route path='countries' element={<Countries />} />
        <Route path='countries/create' element={<CreateCountry />} />
        <Route path='countries/:id' element={<CreateCountry />} />
        <Route path='programs' element={<Programs />} />
        <Route path='programs/create' element={<CreateNewProgram />} />
        <Route path='programs/:codigo' element={<CreateNewProgram />} />
      </Routes>
    </>
  );
};
